import React from 'react';
import { css } from '@emotion/react';
import { motion } from 'framer-motion';

import {
  staticWebinarDimensions,
  withWebinarPlayerContext,
} from '$/components/WebinarPlayer/context';

import isMobile from '$/utils/isMobile';
import { logger } from '$/utils/logger';
import { MessageThread } from './MessageThread';
import { HasJoined } from '../WebinarPlayer/types';

export const AttendeeMessageThread: React.FC = withWebinarPlayerContext(
  [
    'currentRoom',
    'dimensions',
    'attendee',
    'ewebinar',
    'isCollapsedEmbeddedPlayer',
    'showOverlay',
    'showingInVideoFormBeforeWatching',
    'hasJoined',
  ],
  'AttendeeMessageThread'
)((props) => {
  const {
    currentRoom,
    dimensions,
    attendee,
    ewebinar,
    showOverlay,
    hasJoined,
    showingInVideoFormBeforeWatching,
    isCollapsedEmbeddedPlayer,
  } = props.context;

  if (
    !attendee ||
    !currentRoom.hasChat ||
    hasJoined !== HasJoined.Joined ||
    showingInVideoFormBeforeWatching
  ) {
    return null;
  }

  let actionsOffset = '0rem';
  let width = '100%';

  if (dimensions.actionsPane.location !== 'bottom') {
    width = `${dimensions.chat.widthRem}rem`;
    if (isMobile) {
      actionsOffset = `${
        -dimensions.actionsPane.idock.widthRem -
        Math.min(0, dimensions.actionsPane.idock.paddingLeftRem - 1)
      }rem`;
    } else {
      actionsOffset = `-${
        staticWebinarDimensions.actionsPane.idock.widthRem +
        staticWebinarDimensions.actionsPane.idock.paddingLeftRem -
        2
      }rem`;

      if (dimensions.actionsPane.idock.widthRem === 0) {
        actionsOffset = '-1rem';
      }
    }
  }

  logger.debug('ANIM', 'Actionspane offset', { actionsOffset });

  return (
    <motion.div
      className='z-player-chat'
      css={css`
        position: absolute;
        right: 0;
        width: ${width};
        bottom: 0;
        ${isCollapsedEmbeddedPlayer &&
        isMobile &&
        `
          bottom: ${staticWebinarDimensions.videoControlsArea.bottomBar.paddingY}px;
          width: calc(100% - 1rem);
          margin: 0 1rem;
        `}
        height: min(${isCollapsedEmbeddedPlayer ? '95%' : '50%'}, 500px);
        max-height: min(95%, 500px);
        pointer-events: none;
        font-family: '${ewebinar.font ?? 'unset'}';
      `}
      animate={{ y: showOverlay ? '125%' : '0%', x: actionsOffset }}
      variants={{
        'chat.open': { y: '0%' },
        'chat.close': { y: '0%' },
        'chat.gone': { y: '125%' },
        'actions.gone': { x: actionsOffset },
        'actions.close': { x: actionsOffset },
        'actions.open': { x: actionsOffset },
        'actions.button.hide': { x: 0 },
        'actions.button.show': { x: actionsOffset },
      }}
    >
      <MessageThread attendee={attendee} language={ewebinar.viewerRoomSettings.language ?? 'en'} />
    </motion.div>
  );
});
